import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';

export function isSameDay(a: NgbDateStruct | null | undefined, b: NgbDateStruct | null | undefined): boolean {
  return !!a && !!b && a.year === b.year && a.month === b.month && a.day === b.day;
}

/** Tarih filtresinin yanındaki tek günlük hızlı seçim düğmesi. */
export interface QuickDayOption {
  date: NgbDateStruct;
  label: string;
  /** Tam tarih (gg.aa.yyyy); düğmenin ipucu. */
  title: string;
}

const SHORT_DAY_NAMES = ['Paz', 'Pzt', 'Sal', 'Çar', 'Per', 'Cum', 'Cmt'];

/**
 * Bugün dahil son `count` gün, eskiden yeniye — düğmeler soldan sağa takvim
 * sırasında dizilsin ve "Bugün" tarih alanlarından en uzakta kalsın.
 */
export function recentDayOptions(count = 7): QuickDayOption[] {
  const options: QuickDayOption[] = [];

  for (let offset = count - 1; offset >= 0; offset--) {
    const date = new Date();
    date.setDate(date.getDate() - offset);

    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');

    options.push({
      date: { year: date.getFullYear(), month: date.getMonth() + 1, day: date.getDate() },
      label: offset === 0 ? 'Bugün' : offset === 1 ? 'Dün' : `${SHORT_DAY_NAMES[date.getDay()]} ${date.getDate()}`,
      title: `${day}.${month}.${date.getFullYear()}`,
    });
  }

  return options;
}
